export default __webpack_public_path__ + "static/media/pc_img.3098b8b1.png";